import { PersonSearchDialog } from 'components/layout/dialogs/PersonSearchDialog';
import SourceApiRepository from "repositories/api/SourceApiRepository";
import BaseIdbRepository from "repositories/idb/BaseIdbRepository";
import { useWarningNotification } from 'components/hooks/useAppStore';

interface ImpersonateDialogProps {
    onClose: () => void;
}
export const ImpersonateDialog = ({ onClose }: ImpersonateDialogProps) => {

    const addWarningNotification = useWarningNotification();

    const onSelect = async (person:any) => {
        const response = await SourceApiRepository.getImpersonateTokenByPersonIdAsync(person.personID);
        if (response.ok) {
            const data = await response.json();

            await BaseIdbRepository.deleteDatabaseAsync();

            window.location.href = `/?token=${data}`;

        } else {
            addWarningNotification(`Kunne ikke bytte bruker.`);
        }
    }

    return (
        <PersonSearchDialog
            onClose={onClose}
            onSelect={onSelect}
            allTypes={true}
        />
    )
}
